import React, { useState, useRef, useMemo } from 'react';
import { Player } from '@lordicon/react';
import {
  TrackerFeedbackConnectorApollo,
  useAppContext,
  useTranslator,
  useToast,
} from '@front-activerse/common-components';
import { Row, Col } from 'reactstrap';

const TrackerFeedback: React.FC<{ requestId: string }> = ({ requestId }) => {
  const { t } = useTranslator();
  const { toastError } = useToast();
  const {
    // images: { thumbDownActiveIcon, thumbDownDefaultIcon, thumbUpActiveIcon, thumbUpDefaultIcon },
    lotties: { thumbUpIcon, thumbDownIcon },
  } = useAppContext();

  const playerRefThumbUp = useRef<Player>(null);
  const playerRefThumbDown = useRef<Player>(null);

  const iconsIconMiddleColor = useMemo(() => {
    if (typeof document === 'undefined') return '#000000';
    const color = getComputedStyle(document.documentElement)
      .getPropertyValue('--icons-icon-middle-color')
      .trim();
    return color || '#000000';
  }, []);

  const feedbackSuccessFgColor = useMemo(() => {
    if (typeof document === 'undefined') return '#000000';
    const color = getComputedStyle(document.documentElement)
      .getPropertyValue('--button-feedback-button-feedback-button-success-fg-color')
      .trim();
    return color || '#000000';
  }, []);

  const feedbackErrorFgColor = useMemo(() => {
    if (typeof document === 'undefined') return '#000000';
    const color = getComputedStyle(document.documentElement)
      .getPropertyValue('--button-feedback-button-feedback-button-error-fg-color')
      .trim();
    return color || '#000000';
  }, []);

  const [feedbackType, setFeedbackType] = useState<'thumbDown' | 'thumbUp' | null>(null);

  const handleFeedback = async (
    type: 'thumbDown' | 'thumbUp',
    requestId: string,
    requestFeedback: (requestId: string, feedback: boolean) => Promise<any>
  ) => {
    const feedback = type === 'thumbUp';
    setFeedbackType(type);
    const response = await requestFeedback(requestId, feedback);
    if (response.__typename !== 'BasicMutationSuccess') {
      toastError();
    }
  };

  return (
    <TrackerFeedbackConnectorApollo>
      {({ requestFeedback }) => (
        <Row>
          <Col xs="12" md={{ size: 6, offset: 3 }}>
            <div className="d-flex justify-content-between align-items-center mt-l">
              <span className="description text-text-variant-color">
                {t('tracker.aiRecognitionVerificationQuestion')}
              </span>

              <div className="d-flex gap-1">
                <button
                  type="button"
                  className={`feedback-button ${feedbackType === 'thumbUp' ? 'thumb-up' : ''}`}
                  onClick={() => handleFeedback('thumbUp', requestId, requestFeedback)}
                  onMouseEnter={() => playerRefThumbUp.current?.playFromBeginning()}
                  onTouchStart={() => playerRefThumbUp.current?.playFromBeginning()}
                >
                  <Player
                    ref={playerRefThumbUp}
                    icon={thumbUpIcon}
                    size={20}
                    colorize={
                      feedbackType === 'thumbUp' ? feedbackSuccessFgColor : iconsIconMiddleColor
                    }
                  />
                  {t('tracker.aiVerification.yes')}
                </button>
                <button
                  type="button"
                  className={`feedback-button ${feedbackType === 'thumbDown' ? 'thumb-down' : ''}`}
                  onClick={() => handleFeedback('thumbDown', requestId, requestFeedback)}
                  onMouseEnter={() => playerRefThumbDown.current?.playFromBeginning()}
                  onTouchStart={() => playerRefThumbDown.current?.playFromBeginning()}
                >
                  <Player
                    ref={playerRefThumbDown}
                    icon={thumbDownIcon}
                    size={20}
                    colorize={
                      feedbackType === 'thumbDown' ? feedbackErrorFgColor : iconsIconMiddleColor
                    }
                  />
                  {t('tracker.aiVerification.no')}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </TrackerFeedbackConnectorApollo>
  );
};

export default TrackerFeedback;
